import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Input,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import { GameContext } from "../../provider/GameProvider";
import Decimal from "break_infinity.js";

export function CheatMenuDialog(props: {
  open: boolean;
  setOpen: (value: React.SetStateAction<boolean>) => void;
}) {
  const { setGame } = React.useContext(GameContext);
  const [cheatCode, setCheatCode] = React.useState("");

  return (
    <Dialog open={props.open} onClose={() => props.setOpen(false)}>
      <DialogTitle>
        <div style={{ color: "white" }}>Cheat-Menu</div>
      </DialogTitle>
      <DialogContent>
        <FormControl>
          <Input
            placeholder="Enter Cheat-Code"
            value={cheatCode}
            onChange={(event) => setCheatCode(event.target.value)}
            autoFocus
            style={{ color: "white" }}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            if (cheatCode.includes("particles")) {
              const particles = new Decimal(cheatCode.split(" ")[1]);
              setGame((prev) => ({
                ...prev,
                producers: prev.producers.map((producer, index) => {
                  if (index === 0) {
                    return {
                      ...producer,
                      value: producer.value.plus(particles),
                    };
                  }
                  return producer;
                }),
              }));
              props.setOpen(false);
            }
            if (cheatCode.includes("molecules")) {
              const molecules = new Decimal(cheatCode.split(" ")[1]);
              console.log("triggered", molecules.toString());
              setGame((prev) => ({
                ...prev,
                molecule: {
                  ...prev.molecule,
                  value: prev.molecule.value.plus(molecules),
                },
              }));
              props.setOpen(false);
            }
          }}
        >
          <Typography>Submit</Typography>
        </Button>
      </DialogActions>
    </Dialog>
  );
}
